import {Validators} from '@angular/forms';

export class LoanDetailsTermsModel {

  usage = {
    value: {},
    validation: Validators.compose([])
  };

  vehicle = {
    value: {},
    validation: Validators.compose([])
  };

  vehicleType = {
    value: null,
    validation: Validators.compose([])
  };

  variant = {
    value: null,
    validation: Validators.compose([])
  };

  odometerReading = {
    value: null,
    validation: Validators.compose([Validators.pattern('[0-9]*')])
  };

  specs = {
    value: null,
    validation: Validators.compose([])
  };

  homeOwnerDiscount = {
    value: false,
    validation: Validators.compose([]),
    disabled: true
  };

  interestRate = {
    value: null,
    validation: Validators.compose([Validators.required])
  };


  vin = {
    value: null,
    validation: Validators.compose([])
  };

  purpose = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  product = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  productPricing = {
    value: null,
    validation: Validators.compose([])
  };

  allowCards = {
    value: false,
    validation: Validators.compose([])
  };

  interestType = {
    value: null,
    validation: Validators.compose([])
  };

  securityType = {
    value: null,
    validation: Validators.compose([])
  };

  repaymentFrequency = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  loanTermId = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  loanTerm = {
    value: null,
    validation: Validators.compose([])
  };

  fixedTerm = {
    value: null,
    validation: Validators.compose([])
  };

  balloonAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };

  balloonPercentage = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };

  monthlyFee = {
    value: 0,
    validation: Validators.compose([]),
    disabled: true
  };

  monthlyRepayment = {
    value: 0,
    validation: Validators.compose([]),
    disabled: true
  };

  totalMonthlyRepayment = {
    value: 0,
    validation: Validators.compose([]),
    disabled: true
  };
}
